import React, { Component } from 'react';
/* Redux imports */
import { connect } from 'react-redux';
import { searchActions, searchSelectors } from "../../store/search";
import Layout from '../../components/Layout'
import ShareRoster from '../../pages/ShareRoster'
import { withRouter } from 'react-router-dom';
import Loading from '../../components/Base/Loading'

/* Container for My Posts page */

class ShareRosterContainer extends Component {
	constructor(props) {
		super(props);
		this.id = this.props.match.params.roster;
		this.state = {
			width: 0,
			height: 0,
			loading: false,
			roster: { students_uid: [], chat_uid: 1, creator_uid: 1 },
			students: [],
			faculty: []
		};
	}

	componentDidMount() {
		const { clearSearch, clearFilters } = this.props;
		clearSearch();
		clearFilters();
		// console.log(this.id);
		this.setState({ loading: true });
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		this.listener = this.fetchRosterListener();
		this.studentListener = this.fetchRosterListener()
	}

	fetchRoster = async (roster) => {

		const { updateStudents } = this.props;

		let students = [];
		// console.log(roster)
		// for (let item in roster.students_uid) {
		// 	let studentRef = await this.props.firebase.student(roster.students_uid[item]).get();
		// 	let student = {
		// 		id: studentRef.id,
		// 		...studentRef.data()
		// 	};
		// 	students.push(student)
		// }
		let facultyRef = await this.props.firebase.faculties().get();
		let facultyResult = [];
		facultyRef.docs.forEach(doc => facultyResult.push({ id: doc.id, ...doc.data() }));
		// let studentRef = await this.props.firebase.students().where('id', )
		// console.log(facultyRef);
		// console.log('faculty', facultyResult);
		updateStudents(students);
		this.setState({ roster, students, faculty: facultyResult, loading: false })
	};

	fetchRosterListener = () => {
		return this.props.firebase.roster(this.id).onSnapshot(snapshot => {
			let roster = { id: snapshot.id, ...snapshot.data() };

			this.fetchRoster(roster)

		}
		)
	};


	fetchFaculty = async () => {

	};

	componentDidUpdate(prevProps, prevState, snapshot) {

	}

	componentWillUnmount() {
		const { clearPlaceholder } = this.props;
		clearPlaceholder()
		window.removeEventListener('resize', this.updateWindowDimensions);
		this.listener()
		this.studentListener()
	}

	updateWindowDimensions = () => {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	};

	render() {
		const { roster, loading } = this.state;
		return (
			<Layout {...this.props} noSideBar noFooter rosterDetails roster={roster} loading={loading}>
				{loading ? <Loading /> :
					<ShareRoster width={this.state.width} {...this.props} {...this.state} rosterID={this.id}
						updateRoster={() => this.fetchRoster(roster)} />
				}
			</Layout>
		);
	}
}


const mapStateToProps = state => ({
	search: searchSelectors.refreshSearch(state.search),
	currentList: searchSelectors.refreshCurrentResults(state.search)
});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilters: () => {
		dispatch(searchActions.clearFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updatePlaceholder: (placeholder) => {
		dispatch(searchActions.updatePlaceholder(placeholder))
	},
	clearPlaceholder: () => {
		dispatch(searchActions.clearPlaceholder())
	}
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareRosterContainer));
